var _style, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCodeTypingAnimate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-code-typing",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-code-typing:not(.animated) .animable {opacity: 0;}svg#freepik_stories-code-typing.animated #freepik--speech-bubbles--inject-12 {animation: 1.5s Infinite  linear floating;animation-delay: 0.5s;}            @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-12",
    className: "animable",
    style: {
      transformOrigin: "369.183px 242.94px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.1,
    y: 79.59,
    width: 152.3,
    height: 101.97,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "100.25px 130.575px"
    },
    id: "el2jo1ixll28h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.39,181.57s0-.64,0-1.86,0-3,0-5.38c0-4.72,0-11.64-.05-20.51,0-17.71-.07-43.18-.12-74.23l.22.22-152.28.06h0l.27-.28c0,36.33,0,70.88,0,102l-.25-.25,109.72.12,31.34.07,8.34,0h2.15l.74,0h-.71l-2.12,0-8.29,0-31.29.06-109.88.13h-.25v-.25c0-31.1,0-65.65,0-102v-.27h.29l152.28.06h.22v.21c-.05,31.11-.09,56.62-.11,74.37,0,8.84-.05,15.75-.06,20.46,0,2.33,0,4.12,0,5.34S176.39,181.57,176.39,181.57Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "100.325px 130.46px"
    },
    id: "elaiqneerunvh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1,88.69c0-.15,34.06-.27,76.08-.27s76.09.12,76.09.27-34.06.28-76.09.28S24.1,88.85,24.1,88.69Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "100.185px 88.695px"
    },
    id: "el1on0awl33rm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elaydf2qaa4nt"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "28.88px 84.1px"
    },
    className: "animable",
    id: "elpiuklzkp538"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.1,84.1a1.22,1.22,0,0,1-2.44,0,1.22,1.22,0,0,1,2.44,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "28.88px 84.1px"
    },
    id: "elqrg3w4oavf8",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elcbp2owslrxv"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "33.07px 84.1px"
    },
    className: "animable",
    id: "el1b4z67ecqg7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.29,84.1a1.22,1.22,0,1,1-1.22-1.22A1.22,1.22,0,0,1,34.29,84.1Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "33.07px 84.1px"
    },
    id: "eljp7qyjtpt2",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el98lea6ocjbs"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "37.19px 84.1px"
    },
    className: "animable",
    id: "el6c9kdjuuo43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.41,84.1a1.22,1.22,0,1,1-1.22-1.22A1.22,1.22,0,0,1,38.41,84.1Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "37.19px 84.1px"
    },
    id: "eljf0ufsa594",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 37.19,
    y: 99.33,
    width: 40.62,
    height: 40.63,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "57.5px 119.645px"
    },
    id: "elnq3oxymqpcj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.51,110.81c0,.15-15.85.27-35.39.27s-35.39-.12-35.39-.27,15.85-.27,35.39-.27S155.51,110.66,155.51,110.81Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "120.12px 110.81px"
    },
    id: "eln6vko29x6l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.51,118.36c0,.15-15.85.27-35.39.27s-35.39-.12-35.39-.27,15.85-.27,35.39-.27S155.51,118.21,155.51,118.36Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "120.12px 118.36px"
    },
    id: "elk4hppo9p1e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.51,125.91c0,.15-15.85.27-35.39.27s-35.39-.12-35.39-.27,15.85-.27,35.39-.27S155.51,125.76,155.51,125.91Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "120.12px 125.91px"
    },
    id: "elfadkr9s4vb4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.56,133.46a9.76,9.76,0,0,1-1.64.11l-4.48.08c-3.79,0-9,.08-14.79.08s-11,0-14.79-.08l-4.48-.08a10,10,0,0,1-1.65-.11,10,10,0,0,1,1.65-.11l4.48-.08c3.78-.05,9-.08,14.79-.08s11,0,14.79.08l4.48.08A9.76,9.76,0,0,1,126.56,133.46Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "105.645px 133.46px"
    },
    id: "elgs8vcz7w1n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.73,
    y: 153.65,
    width: 19.09,
    height: 19.09,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "49.275px 163.195px"
    },
    id: "el4rcqx2js1ug",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.35,
    y: 153.65,
    width: 19.09,
    height: 19.09,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "83.895px 163.195px"
    },
    id: "el5zimbon9cak",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.98,
    y: 153.65,
    width: 19.09,
    height: 19.09,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "118.525px 163.195px"
    },
    id: "ell74g03f30y7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.6,
    y: 153.65,
    width: 19.09,
    height: 19.09,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "153.145px 163.195px"
    },
    id: "eludpuea6jy8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.87,
    y: 30.04,
    width: 131.19,
    height: 53.29,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "264.465px 56.685px"
    },
    id: "el0j90edfp0yw4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.06,83.33s0-.33,0-1,0-1.56,0-2.77c0-2.43,0-6,0-10.6,0-9.2-.05-22.5-.08-39l.15.15-131.19.06h0l.2-.21c0,18.66,0,36.68,0,53.29l-.19-.2,94.06.09,27.28.06,7.31,0h0l-7.26,0-27.24.05-94.19.1h-.2v-.2c0-16.61,0-34.63,0-53.29v-.21h.21l131.19.07h.14V30c0,16.51-.06,29.84-.08,39.06,0,4.58,0,8.15,0,10.57,0,1.2,0,2.11,0,2.74S330.06,83.33,330.06,83.33Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "264.48px 56.5px"
    },
    id: "ellyvt42qp8j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,37.23c0-.12,29.32-.21,65.48-.21s65.5.09,65.5.21-29.32.21-65.5.21S199,37.34,199,37.23Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "264.49px 37.23px"
    },
    id: "els6by59ifnpj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ela9bcv06slga"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "203.54px 33.9993px"
    },
    className: "animable",
    id: "eli56vx11292"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.49,34a.95.95,0,1,1-1-.95A1,1,0,0,1,204.49,34Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "203.54px 33.9993px"
    },
    id: "el1op6fnmgc17",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elo02tfhlyjtj"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "206.8px 34px"
    },
    className: "animable",
    id: "ell0yfwrikeef"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.75,34a.95.95,0,1,1-.95-.95A1,1,0,0,1,207.75,34Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "206.8px 34px"
    },
    id: "ely73esgm092c",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el04mhtvvvt9n"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "210.02px 34.01px"
    },
    className: "animable",
    id: "el35bg8qax8it"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 210.02,
    cy: 34.01,
    r: 0.95,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "210.02px 34.01px"
    },
    id: "eljdii9ruhv6",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 210.02,
    y: 45.89,
    width: 31.69,
    height: 31.69,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "225.865px 61.735px"
    },
    id: "elp7j80hvqyon",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,54.38c0,.12-16.31.21-36.42.21s-36.42-.09-36.42-.21,16.31-.21,36.42-.21S321,54.27,321,54.38Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "284.58px 54.38px"
    },
    id: "eltzpx1lto84o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,60.84c0,.11-16.31.2-36.42.2s-36.42-.09-36.42-.2,16.31-.21,36.42-.21S321,60.72,321,60.84Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "284.58px 60.835px"
    },
    id: "el8zcyc1ftq9w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,67.29a1.61,1.61,0,0,1-.48,0l-1.36,0-5,.07-16.57.06L255,67.44l-5-.07-1.37,0a1.68,1.68,0,0,1-.48,0,2.32,2.32,0,0,1,.48,0l1.37,0,5-.06,16.58-.07,16.57.07,5,.06,1.36,0A2.2,2.2,0,0,1,295,67.29Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "271.575px 67.34px"
    },
    id: "el20psgxlr0mf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684,101.16a4.68,4.68,0,0,1,.74-.85c.59-.58,1.31-1.31,2.16-2.16,1.83-1.82,4.39-4.3,7.24-7l.07-.06v.36c-2.87-2.66-5.45-5.09-7.29-6.87l-2.17-2.12a5,5,0,0,1-.75-.83,4.57,4.57,0,0,1,.88.68l2.28,2c1.9,1.71,4.52,4.1,7.39,6.76l.2.19-.2.18-.06.06c-2.85,2.72-5.45,5.16-7.35,6.9l-2.26,2.06A6.07,6.07,0,0,1,684,101.16Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "689.375px 91.395px"
    },
    id: "elsh6fxgda7f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.87,81.62a5.39,5.39,0,0,1-.74.84L659,84.63c-1.83,1.81-4.39,4.29-7.24,7l-.07.06v-.37c2.87,2.67,5.45,5.1,7.29,6.88l2.17,2.12a4.53,4.53,0,0,1,.75.83,5,5,0,0,1-.88-.69l-2.28-2c-1.9-1.71-4.52-4.1-7.39-6.77l-.2-.18.2-.18.06-.07c2.85-2.71,5.45-5.15,7.35-6.9L661,82.32A4.66,4.66,0,0,1,661.87,81.62Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "656.525px 91.385px"
    },
    id: "el49zigglriol",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.56,105.76c-.13-.05,2.19-6.58,5.19-14.59s5.53-14.47,5.66-14.42-2.2,6.58-5.19,14.59S667.69,105.81,667.56,105.76Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "672.985px 91.255px"
    },
    id: "elhp55v26ob7r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.19,119.74s0-.38,0-1.09,0-1.78,0-3.14c0-2.76,0-6.79,0-11.91,0-10.25-.06-24.9-.11-42.56l.21.21-72,0h0l.25-.25c0,21.22,0,41.26,0,58.7l-.22-.22,52,.11,14.74.06,3.92,0h1.36l-.33,0h-1l-3.87,0-14.7.06-52.17.11h-.22v-.23c0-17.44,0-37.48,0-58.7v-.25h.26l72,0h.21V61c0,17.71-.08,32.41-.11,42.69,0,5.11,0,9.11,0,11.86,0,1.35,0,2.39,0,3.11S709.19,119.74,709.19,119.74Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "673.285px 90.23px"
    },
    id: "elo83yy8b9c7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.76,69.75c0,.14-16.27.25-36.33.25s-36.32-.11-36.32-.25,16.26-.25,36.32-.25S709.76,69.61,709.76,69.75Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "673.435px 69.75px"
    },
    id: "ellvkvooxv05s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643,65.46a1,1,0,1,1-1-1A1,1,0,0,1,643,65.46Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "642px 65.46px"
    },
    id: "elualuy3fy64k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.56,65.46a1,1,0,1,1-1-1A1,1,0,0,1,646.56,65.46Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "645.56px 65.46px"
    },
    id: "eljegd3rt3c3i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.09,65.46a1,1,0,1,1-1-1A1,1,0,0,1,650.09,65.46Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "649.09px 65.46px"
    },
    id: "elkixl2xd6508",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.59,377.9c4.16-2.15,9.07-2.43,13.69-1.66,2.48.41,5.07,1.15,6.76,3s2,5.14.07,6.75a6.55,6.55,0,0,1-4.26,1.08c-3.62,0-7.64-.68-10.53,1.5-1.65,1.24-2.74,3.3-4.72,3.91a4.66,4.66,0,0,1-5.13-2.28,8,8,0,0,1-.58-5.88A9,9,0,0,1,692.59,377.9Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "701.007px 384.225px"
    },
    id: "eljjhqfh7o6ll",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.05,359.49c2.55,3.63,7.5,2.43,9.79.21s3.26-5.44,4.15-8.5c2-7,4-14.36,2.55-21.5a12,12,0,0,0-2.75-5.85,6.23,6.23,0,0,0-5.91-2c-2.5.66-4,3.1-5.17,5.42a51.26,51.26,0,0,0-5.06,22c0,3.54.4,7.25,2.4,10.18",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "690.343px 341.766px"
    },
    id: "el59lvsxzoepm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.06,364.7c2.76-3.28,3.29-8.06,2.06-12.17a23.46,23.46,0,0,0-7.21-10.46A38.88,38.88,0,0,0,658,334.45a13.86,13.86,0,0,0-5.81-1,6.12,6.12,0,0,0-4.88,3c-1.35,2.59,0,5.74,1.36,8.3a98.45,98.45,0,0,0,8.48,12.92c2.54,3.27,5.45,6.51,9.33,8s7.9,1.31,9.95-1.38",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "662.749px 350.02px"
    },
    id: "elu255htc3xt9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.88,414.34a8.29,8.29,0,0,0,.23-1.66c.12-1.2.26-2.71.44-4.51s.49-4.15,1-6.61a51.47,51.47,0,0,1,2.41-7.81,28.8,28.8,0,0,1,4-7.06,15,15,0,0,1,5-4.19,14.18,14.18,0,0,1,4.25-1.32,7.69,7.69,0,0,0,1.64-.24,8.6,8.6,0,0,0-1.67,0,12.77,12.77,0,0,0-4.43,1.15,14.89,14.89,0,0,0-5.31,4.22,28.24,28.24,0,0,0-4.14,7.21,47.94,47.94,0,0,0-2.38,7.93,56.11,56.11,0,0,0-.88,6.7c-.14,1.92-.2,3.47-.23,4.54A7.58,7.58,0,0,0,682.88,414.34Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "692.322px 397.62px"
    },
    id: "elp2q4zqene1a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.19,410.87a3.39,3.39,0,0,0,0-.77v-2.19c0-1.91,0-4.66.1-8.06.16-6.8.75-14.12,1.88-24.43,1.07-9.7,2.51-21,4-28.34.32-1.67.65-3.17,1-4.48s.54-2.46.78-3.38.38-1.57.52-2.13a3.24,3.24,0,0,0,.13-.76,4.49,4.49,0,0,0-.27.72q-.24.82-.63,2.1c-.28.92-.57,2-.9,3.36s-.71,2.81-1.07,4.47a249.06,249.06,0,0,0-4.23,26.29c-1.13,10.34-1.64,19.76-1.69,26.57,0,3.41,0,6.17.12,8.07.06.89.1,1.62.14,2.19A3.87,3.87,0,0,0,683.19,410.87Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "687.205px 373.6px"
    },
    id: "elf09abjlo2l5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.24,392.71a17.42,17.42,0,0,0,0-2.29c-.08-1.47-.29-3.6-.7-6.2a82.83,82.83,0,0,0-2-9,74,74,0,0,0-3.78-10.7,57.22,57.22,0,0,0-11.1-17.29,27.72,27.72,0,0,0-2.61-2.42c-.4-.34-.76-.68-1.12-.95l-1-.7a14.27,14.27,0,0,0-1.93-1.23,68.67,68.67,0,0,1,6.32,5.64,59.9,59.9,0,0,1,10.82,17.22,84.12,84.12,0,0,1,3.81,10.6A89.48,89.48,0,0,1,682,384.3c.48,2.58.75,4.68.92,6.14A13.57,13.57,0,0,0,683.24,392.71Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "671.139px 367.32px"
    },
    id: "elvxt75p88ocm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "665.69 424.74 667.51 449.66 699.53 449.66 701.35 424.74 665.69 424.74",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "683.52px 437.2px"
    },
    id: "elvpr3ew0nfcs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 662.59,
    y: 414.91,
    width: 42.57,
    height: 9.82,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "683.875px 419.82px"
    },
    id: "elk8734wrbyq7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "662.59 448.71 662.59 451.43 664.59 451.43 704.46 451.43 704.46 448.71 662.59 448.71",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "683.525px 450.07px"
    },
    id: "elmip56k72bh9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "666.55 456.23 664.59 451.43 702.94 451.43 700.65 456.23 666.55 456.23",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "683.765px 453.83px"
    },
    id: "elunr3ku92x4s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.75,432.88s0,.09-.15.23l-.48.64-1.86,2.38-.08.11-.09-.11c-1.17-1.62-2.73-3.79-4.58-6.34h.27l-4.52,6.39-.14.2-.16-.19-5.35-6.36h.31l-.29.37-4.79,6-.16.2-.14-.21c-1.63-2.3-3.15-4.44-4.52-6.39l.26,0-5.55,6.33-.1.11-.08-.12-1.74-2.93-.45-.78a1.39,1.39,0,0,1-.13-.27s.07.07.18.24l.5.75,1.83,2.87h-.18l5.47-6.41.14-.16.12.17,4.56,6.36h-.31l4.78-6,.29-.37.15-.19.16.19,5.33,6.38H689l4.56-6.36.14-.18.13.18,4.48,6.41h-.16l1.94-2.33.52-.6A1.17,1.17,0,0,1,700.75,432.88Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "683.49px 432.9px"
    },
    id: "el8qtefqjfe55",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.79,424.57c0,.11-8,.2-17.92.2s-17.92-.09-17.92-.2,8-.2,17.92-.2S701.79,424.46,701.79,424.57Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "683.87px 424.57px"
    },
    id: "elbspzzmwvp4q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.41,451.7c0,.11-8.72.2-19.47.2s-19.48-.09-19.48-.2,8.72-.2,19.48-.2S703.41,451.59,703.41,451.7Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "683.935px 451.7px"
    },
    id: "elkez4qdjtguq",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-12",
    className: "animable",
    style: {
      transformOrigin: "364.025px 280.155px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.14,104.09H620a6.74,6.74,0,0,1,6.74,6.74V437a14.57,14.57,0,0,1-14.57,14.57H116A14.57,14.57,0,0,1,101.39,437V111.85A7.75,7.75,0,0,1,109.14,104.09Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "364.065px 277.83px"
    },
    id: "elndls2riz4y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.42,425.83H648.63a0,0,0,0,1,0,0V442.5a13.72,13.72,0,0,1-13.72,13.72H93.14A13.72,13.72,0,0,1,79.42,442.5V425.83a0,0,0,0,1,0,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "364.025px 441.025px"
    },
    id: "elldam0xbqeag",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.49,
    y: 117.9,
    width: 495.7,
    height: 293.4,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "363.34px 264.6px"
    },
    id: "elhwjy0vjgwsf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.29 425.83 319.35 437.06 418.74 437.06 425.3 425.83 312.29 425.83",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "368.795px 431.445px"
    },
    id: "elx3u85ct3s8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.2,
    y: 134.9,
    width: 467.48,
    height: 276.4,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "363.94px 273.1px"
    },
    id: "elgrcepbnwbz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.07,403.18c-.24,0-.44-58.86-.44-131.46s.2-131.49.44-131.49.44,58.86.44,131.49S166.31,403.18,166.07,403.18Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "166.07px 271.705px"
    },
    id: "elg2oqo3r5fn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.64,164.07c0,.24-3.4.44-7.59.44s-7.6-.2-7.6-.44,3.4-.44,7.6-.44S156.64,163.83,156.64,164.07Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "149.045px 164.07px"
    },
    id: "elwq3g8pmchzb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.22,149.15c0,.24-3.4.44-7.59.44s-7.59-.2-7.59-.44,3.4-.44,7.59-.44S157.22,148.91,157.22,149.15Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "149.63px 149.15px"
    },
    id: "elrp3ryx6o2he",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.64,180.15c0,.24-3.4.44-7.59.44s-7.6-.2-7.6-.44,3.4-.44,7.6-.44S156.64,179.91,156.64,180.15Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "149.045px 180.15px"
    },
    id: "el05jv5f9qkira",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.64,196.23c0,.25-3.4.44-7.59.44s-7.6-.19-7.6-.44,3.4-.43,7.6-.43S156.64,196,156.64,196.23Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "149.045px 196.235px"
    },
    id: "ela993ggqbfuj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.64,212.32c0,.24-3.4.44-7.59.44s-7.6-.2-7.6-.44,3.4-.44,7.6-.44S156.64,212.07,156.64,212.32Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "149.045px 212.32px"
    },
    id: "el0akxxddw2z4p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.64,228.4c0,.24-3.4.44-7.59.44s-7.6-.2-7.6-.44,3.4-.44,7.6-.44S156.64,228.16,156.64,228.4Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "149.045px 228.4px"
    },
    id: "elhyy7i9662w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.64,244.48c0,.24-3.4.44-7.59.44s-7.6-.2-7.6-.44,3.4-.44,7.6-.44S156.64,244.24,156.64,244.48Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "149.045px 244.48px"
    },
    id: "elln1p4t9d7vm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.64,260.56c0,.25-3.4.44-7.59.44s-7.6-.19-7.6-.44,3.4-.43,7.6-.43S156.64,260.32,156.64,260.56Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "149.045px 260.565px"
    },
    id: "elgg7t6av2b3l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.64,276.65c0,.24-3.4.43-7.59.43s-7.6-.19-7.6-.43,3.4-.44,7.6-.44S156.64,276.4,156.64,276.65Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "149.045px 276.645px"
    },
    id: "elv1fofc3in8r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.64,292.73c0,.24-3.4.44-7.59.44s-7.6-.2-7.6-.44,3.4-.44,7.6-.44S156.64,292.49,156.64,292.73Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "149.045px 292.73px"
    },
    id: "el3fnn38u58rt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.64,308.81c0,.24-3.4.44-7.59.44s-7.6-.2-7.6-.44,3.4-.44,7.6-.44S156.64,308.57,156.64,308.81Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "149.045px 308.81px"
    },
    id: "el95c4wm5ywjn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.64,324.89c0,.25-3.4.44-7.59.44s-7.6-.19-7.6-.44,3.4-.43,7.6-.43S156.64,324.65,156.64,324.89Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "149.045px 324.895px"
    },
    id: "eldhtq5ey0yxk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.64,341c0,.24-3.4.43-7.59.43s-7.6-.19-7.6-.43,3.4-.44,7.6-.44S156.64,340.73,156.64,341Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "149.045px 340.995px"
    },
    id: "elz0jpyhv2unm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.64,357.06c0,.24-3.4.44-7.59.44s-7.6-.2-7.6-.44,3.4-.44,7.6-.44S156.64,356.82,156.64,357.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "149.045px 357.06px"
    },
    id: "elbvodc5pxhdk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.64,373.14c0,.24-3.4.44-7.59.44s-7.6-.2-7.6-.44,3.4-.44,7.6-.44S156.64,372.9,156.64,373.14Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "149.045px 373.14px"
    },
    id: "elpnur8tstv1q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.64,389.22c0,.25-3.4.44-7.59.44s-7.6-.19-7.6-.44,3.4-.44,7.6-.44S156.64,389,156.64,389.22Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "149.045px 389.22px"
    },
    id: "elvaxfwt5ygr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.51,163.12c0,.24-8.82.44-19.7.44s-19.71-.2-19.71-.44,8.82-.44,19.71-.44S217.51,162.88,217.51,163.12Z",
    style: {
      fill: "#9FC41C",
      transformOrigin: "197.805px 163.12px"
    },
    id: "ely86gu073c8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.51,389.22c0,.25-8.82.44-19.7.44s-19.71-.19-19.71-.44,8.82-.44,19.71-.44S217.51,389,217.51,389.22Z",
    style: {
      fill: "#9FC41C",
      transformOrigin: "197.805px 389.22px"
    },
    id: "elc0e4xnmirx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.4,196.23c0,.25-16.51.44-36.87.44s-36.87-.19-36.87-.44,16.5-.43,36.87-.43S272.4,196,272.4,196.23Z",
    style: {
      fill: "#9FC41C",
      transformOrigin: "235.53px 196.235px"
    },
    id: "elbhzqqlcr9t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.68,196.23c0,.25-16.51.44-36.87.44s-36.88-.19-36.88-.44,16.51-.43,36.88-.43S357.68,196,357.68,196.23Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "320.805px 196.235px"
    },
    id: "elu4qoyn0o0nd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.09,212.32c0,.24-24.33.44-54.34.44s-54.34-.2-54.34-.44,24.32-.44,54.34-.44S325.09,212.07,325.09,212.32Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "270.75px 212.32px"
    },
    id: "elwkryr86b3xo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.09,228.4c0,.24-24.33.44-54.34.44s-54.34-.2-54.34-.44,24.32-.44,54.34-.44S325.09,228.16,325.09,228.4Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "270.75px 228.4px"
    },
    id: "elqawemapwseb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.9,276.65c0,.24-24.34.43-54.34.43s-54.35-.19-54.35-.43,24.33-.44,54.35-.44S399.9,276.4,399.9,276.65Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "345.555px 276.645px"
    },
    id: "el6rqmd5yeix8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.61,244.48c0,.24-24.33.44-54.33.44s-54.35-.2-54.35-.44,24.33-.44,54.35-.44S367.61,244.24,367.61,244.48Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "313.27px 244.48px"
    },
    id: "elx7bvj0m96v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.42,244.48c0,.24-24.33.44-54.33.44s-54.35-.2-54.35-.44,24.33-.44,54.35-.44S500.42,244.24,500.42,244.48Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "446.08px 244.48px"
    },
    id: "el32v2eqeh6j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.24,212.32c0,.24-24.34.44-54.34.44s-54.34-.2-54.34-.44,24.32-.44,54.34-.44S454.24,212.07,454.24,212.32Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "399.9px 212.32px"
    },
    id: "elnoawwdrahjk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.31,276.65c0,.24-24.33.43-54.34.43s-54.34-.19-54.34-.43,24.32-.44,54.34-.44S529.31,276.4,529.31,276.65Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "474.97px 276.645px"
    },
    id: "elf9qfix21c7d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.32,228.4c0,.24-37.78.44-84.38.44s-84.38-.2-84.38-.44,37.77-.44,84.38-.44S514.32,228.16,514.32,228.4Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "429.94px 228.4px"
    },
    id: "el685wg56vk4o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.51,180.15c0,.24-8.82.44-19.7.44s-19.71-.2-19.71-.44,8.82-.44,19.71-.44S217.51,179.91,217.51,180.15Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "197.805px 180.15px"
    },
    id: "elr81f93etc8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.51,373.14c0,.24-8.82.44-19.7.44s-19.71-.2-19.71-.44,8.82-.44,19.71-.44S217.51,372.9,217.51,373.14Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "197.805px 373.14px"
    },
    id: "elvk9b4193mlg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,244.48c0,.24-8.82.44-19.71.44s-19.71-.2-19.71-.44,8.83-.44,19.71-.44S237,244.24,237,244.48Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "217.29px 244.48px"
    },
    id: "elchb4288jvl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.93,244.48c0,.24-8.82.44-19.7.44s-19.71-.2-19.71-.44,8.82-.44,19.71-.44S552.93,244.24,552.93,244.48Z",
    style: {
      fill: "#9FC41C",
      transformOrigin: "533.225px 244.48px"
    },
    id: "el7egcsk2mm6f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.4,308.72c0,.24-16.51.44-36.87.44s-36.87-.2-36.87-.44,16.5-.44,36.87-.44S272.4,308.47,272.4,308.72Z",
    style: {
      fill: "#9FC41C",
      transformOrigin: "235.53px 308.72px"
    },
    id: "ellulw00cely",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.68,308.72c0,.24-16.51.44-36.87.44s-36.88-.2-36.88-.44,16.51-.44,36.88-.44S357.68,308.47,357.68,308.72Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "320.805px 308.72px"
    },
    id: "el06xanpplnh4n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.09,324.8c0,.24-24.33.44-54.34.44s-54.34-.2-54.34-.44,24.32-.44,54.34-.44S325.09,324.56,325.09,324.8Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "270.75px 324.8px"
    },
    id: "el5s71v61m2ys",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.09,340.88c0,.24-24.33.44-54.34.44s-54.34-.2-54.34-.44,24.32-.44,54.34-.44S325.09,340.64,325.09,340.88Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "270.75px 340.88px"
    },
    id: "elr0fyfgklzxh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.61,357c0,.25-24.33.44-54.33.44s-54.35-.19-54.35-.44,24.33-.43,54.35-.43S367.61,356.72,367.61,357Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "313.27px 357.005px"
    },
    id: "elaphot96pj4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.42,357c0,.25-24.33.44-54.33.44s-54.35-.19-54.35-.44,24.33-.43,54.35-.43S500.42,356.72,500.42,357Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "446.08px 357.005px"
    },
    id: "eldc394jxz1cg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.24,324.8c0,.24-24.34.44-54.34.44s-54.34-.2-54.34-.44,24.32-.44,54.34-.44S454.24,324.56,454.24,324.8Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "399.9px 324.8px"
    },
    id: "elgt9qtjkibw6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.32,340.88c0,.24-37.78.44-84.38.44s-84.38-.2-84.38-.44,37.77-.44,84.38-.44S514.32,340.64,514.32,340.88Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "429.94px 340.88px"
    },
    id: "ela5kt92n9x5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,357c0,.25-8.82.44-19.71.44s-19.71-.19-19.71-.44,8.83-.43,19.71-.43S237,356.72,237,357Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "217.29px 357.005px"
    },
    id: "ele08giyfcvmo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.93,357c0,.25-8.82.44-19.7.44s-19.71-.19-19.71-.44,8.82-.43,19.71-.43S552.93,356.72,552.93,357Z",
    style: {
      fill: "#9FC41C",
      transformOrigin: "533.225px 357.005px"
    },
    id: "elx86vgnba8kh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.44,436c0,.14-100.64.26-224.76.26S113.9,436.12,113.9,436s100.62-.26,224.78-.26S563.44,435.84,563.44,436Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "338.67px 436px"
    },
    id: "el8k075rq5f7k",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-12",
    className: "animable",
    style: {
      transformOrigin: "96.135px 346.475px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.07,347.83a57.06,57.06,0,0,0-54.45-14.95,99.15,99.15,0,0,0,55.1,17.21",
    style: {
      fill: "#9FC41C",
      transformOrigin: "70.17px 340.601px"
    },
    id: "eleriyhp3qbb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6,282.43c2.27-16.05-4-34.1-16-45.76-.39,15.9,6.32,33.79,16,45.76",
    style: {
      fill: "#9FC41C",
      transformOrigin: "70.8216px 259.55px"
    },
    id: "elk7iqepr9hw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.21,312.74a85.64,85.64,0,0,0-39.35-37.61,54.08,54.08,0,0,0,39.5,37.78",
    style: {
      fill: "#9FC41C",
      transformOrigin: "68.61px 294.02px"
    },
    id: "elklbob0z9n0g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2,318.58c-9.69.28-19.5-.06-28.87-2.54S43,308.79,36.74,301.37a96.45,96.45,0,0,1,53.31,16.27",
    style: {
      fill: "#9FC41C",
      transformOrigin: "63.47px 310.016px"
    },
    id: "el5jcnfysr8jv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.28,299.32c4.92-18.44,13-31.19,27.53-41.52a38.33,38.33,0,0,1-27.53,41.52",
    style: {
      fill: "#9FC41C",
      transformOrigin: "99.1872px 278.56px"
    },
    id: "el813xb3l0c7e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.86,331.12a27.28,27.28,0,0,0-16.58-25.28c.81,9.52,8.29,20.53,16.58,25.28",
    style: {
      fill: "#9FC41C",
      transformOrigin: "113.57px 318.48px"
    },
    id: "elmqznah5to3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.49,315.57a40.68,40.68,0,0,1,26.64-34.69c-3.35,15.41-12.25,28.24-26.64,34.69",
    style: {
      fill: "#9FC41C",
      transformOrigin: "139.81px 298.225px"
    },
    id: "elh03ri7hgbtn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.51,343.16c3.42-4.89,9-7.93,14.77-9.44s11.8-1.65,17.76-1.77A41.53,41.53,0,0,1,120,345.31",
    style: {
      fill: "#9FC41C",
      transformOrigin: "135.775px 338.644px"
    },
    id: "el3j1a8pf6dv4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.59,382.45a45.5,45.5,0,0,1,55.56,26.33C148,405,128.05,396,112.59,382.45",
    style: {
      fill: "#9FC41C",
      transformOrigin: "140.37px 394.604px"
    },
    id: "elyk8jgaotv4d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.44,368.8c3.35,9.91,2.7,21.89-4.75,30.43a36.34,36.34,0,0,1,4.75-30.43",
    style: {
      fill: "#9FC41C",
      transformOrigin: "88.3105px 384.015px"
    },
    id: "el9ir0jmdx8vh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.34,363.29a37.28,37.28,0,0,1-20.59,30.26,2.34,2.34,0,0,1-1.82.3c-.91-.37-1-1.61-.88-2.59,1.46-12.69,10.87-25,23.29-28",
    style: {
      fill: "#9FC41C",
      transformOrigin: "65.6739px 378.589px"
    },
    id: "eldgo2u4lyhnn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.79,362a30.58,30.58,0,0,1-44.67.23c14.2-1.55,30.58-2.59,44.67-.23",
    style: {
      fill: "#9FC41C",
      transformOrigin: "46.455px 366.21px"
    },
    id: "elwcx56y4hlcs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.66,248.49s0,.15.13.42l.44,1.2c.4,1.08,1,2.62,1.71,4.6s1.65,4.44,2.67,7.29l1.64,4.56L75,271.69c2.52,7.19,5.31,15.82,8.33,25.43s6.07,20.25,9.13,31.47,5.69,22,8,31.78,4.12,18.69,5.49,26.19q.53,2.81,1,5.34t.81,4.77c.51,3,.95,5.55,1.25,7.66s.57,3.71.74,4.85q.14.79.21,1.26a2.72,2.72,0,0,0,.09.43,2.43,2.43,0,0,0,0-.44c0-.31-.09-.73-.16-1.26-.15-1.14-.36-2.78-.64-4.87s-.67-4.69-1.16-7.68c-.24-1.49-.5-3.09-.77-4.78s-.63-3.48-1-5.35c-1.33-7.51-3.19-16.39-5.38-26.23S96,339.68,93,328.44,86.82,306.6,83.83,297s-5.88-18.23-8.44-25.4q-1-2.7-1.81-5.13l-1.69-4.55c-1-2.84-2-5.28-2.75-7.26s-1.39-3.49-1.81-4.56c-.21-.5-.37-.89-.48-1.18A3,3,0,0,0,66.66,248.49Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "88.36px 329.68px"
    },
    id: "elgjcm4b7ivid",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.66,289.11s-.09.07-.25.23l-.68.71c-.59.63-1.45,1.58-2.52,2.83A98.46,98.46,0,0,0,132.85,304a74.82,74.82,0,0,0-8.74,18.71c-2.35,7.44-3.8,15.9-5.25,24.75-2.88,17.7-6.43,33.56-9,45-1.29,5.71-2.34,10.34-3.08,13.58-.35,1.57-.62,2.81-.81,3.69-.09.4-.15.72-.2,1a1.05,1.05,0,0,0,0,.33s0-.11.1-.32.15-.56.25-.95l.92-3.67c.77-3.24,1.88-7.85,3.24-13.55,2.66-11.45,6.27-27.3,9.16-45,1.45-8.85,2.88-17.29,5.18-24.7a75.68,75.68,0,0,1,8.59-18.64,108.93,108.93,0,0,1,8.2-11.22c1-1.26,1.88-2.23,2.44-2.88l.64-.75Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "125.208px 350.085px"
    },
    id: "el490k9bqzclu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.55,361.4a1.74,1.74,0,0,0,.51.09l1.47.17,1.06.1,1.26.19c.9.13,1.93.27,3,.51l1.77.36,1.89.47c1.31.3,2.67.78,4.12,1.22a61.35,61.35,0,0,1,9,4,51.22,51.22,0,0,1,8.06,5.6,38.41,38.41,0,0,1,3.09,3,32.77,32.77,0,0,1,2.45,2.82,29.38,29.38,0,0,1,1.81,2.5,17.24,17.24,0,0,1,1.24,2l.75,1.27c.18.29.28.44.3.43a1.56,1.56,0,0,0-.2-.47l-.67-1.33a15.44,15.44,0,0,0-1.17-2,26.41,26.41,0,0,0-1.76-2.56,29.72,29.72,0,0,0-2.42-2.9,40.62,40.62,0,0,0-3.09-3A49.41,49.41,0,0,0,88.92,368a58,58,0,0,0-9.1-4c-1.46-.42-2.83-.89-4.16-1.17l-1.91-.45L72,362.09c-1.13-.23-2.17-.34-3.08-.44l-1.26-.15-1.07-.05-1.48-.06A1.89,1.89,0,0,0,64.55,361.4Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "85.44px 373.752px"
    },
    id: "el9336cix5riw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5,289.45a6.82,6.82,0,0,0,1,1L64.45,293c2.48,2.12,5.94,5,9.77,8.21s7.34,6,9.88,8.08l3,2.41a8.11,8.11,0,0,0,1.16.82,7.3,7.3,0,0,0-1-1L84.34,309c-2.48-2.12-5.93-5-9.77-8.2s-7.33-6-9.87-8.08l-3-2.41A6.94,6.94,0,0,0,60.5,289.45Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "74.38px 300.985px"
    },
    id: "el28w23q6e4rg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,308.23c0,.15,7.42,2.47,16.65,5.2s16.77,4.83,16.81,4.69-7.41-2.48-16.65-5.21S57.06,308.09,57,308.23Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "73.7301px 313.175px"
    },
    id: "elh2jbq7nv9wa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.54,300.75a5.78,5.78,0,0,0,.77-1.07l2-3c1.66-2.52,4-6,6.83-9.63s5.5-6.85,7.48-9.13l2.36-2.69a5.88,5.88,0,0,0,.83-1,6,6,0,0,0-1,.88c-.61.6-1.46,1.48-2.49,2.59-2.07,2.21-4.82,5.38-7.63,9.05s-5.14,7.17-6.73,9.75c-.79,1.29-1.41,2.35-1.82,3.09A7.08,7.08,0,0,0,84.54,300.75Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "94.675px 287.49px"
    },
    id: "elvih8f0vaxeo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.43,311.18a26.69,26.69,0,0,0,1.75,2.88c1.12,1.75,2.63,4.18,4.19,6.93s2.89,5.29,3.82,7.15a25.89,25.89,0,0,0,1.58,3,17.13,17.13,0,0,0-1.23-3.14c-.85-1.9-2.12-4.48-3.7-7.25s-3.14-5.18-4.34-6.88A17.69,17.69,0,0,0,110.43,311.18Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "116.1px 321.16px"
    },
    id: "elhs0zxdp263n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.29,343.67c0,.07,1.46-.62,3.79-1.67s5.58-2.42,9.25-3.7,7.07-2.25,9.55-2.88,4-1,4-1.05a4,4,0,0,0-1.11.11c-.71.11-1.73.3-3,.57a82.77,82.77,0,0,0-18.87,6.6c-1.15.57-2.07,1.06-2.69,1.42A4.31,4.31,0,0,0,119.29,343.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "132.585px 339.021px"
    },
    id: "el93v886ewxx6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.32,382.51s.15.08.46.16l1.34.34,5,1.15a162.32,162.32,0,0,1,16.19,4.27,71.7,71.7,0,0,1,15.11,7.1c1.81,1.15,3.22,2.17,4.17,2.9a16.14,16.14,0,0,0,1.5,1.11s-.11-.14-.34-.36-.57-.54-1-.92a45,45,0,0,0-4.09-3.05,66.09,66.09,0,0,0-15.14-7.29,135.27,135.27,0,0,0-16.29-4.14l-5-1A15.25,15.25,0,0,0,112.32,382.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "134.205px 391.025px"
    },
    id: "el42lwj0zz8k8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1,392.09c.15,0,1-5.21,2-11.68s1.6-11.74,1.45-11.76-1,5.21-2,11.68S87,392.07,87.1,392.09Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "88.8306px 380.37px"
    },
    id: "elg4rjyh3xs3f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.84,382.56a27.72,27.72,0,0,0,2.37-2.81c1.42-1.77,3.38-4.2,5.61-6.85s4.28-5,5.78-6.7A29.16,29.16,0,0,0,77,363.38a3.73,3.73,0,0,0-.76.65c-.46.43-1.1,1.09-1.89,1.91-1.57,1.64-3.68,4-5.91,6.61s-4.15,5.13-5.49,7c-.68.92-1.21,1.67-1.56,2.19A3.65,3.65,0,0,0,60.84,382.56Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "68.92px 372.97px"
    },
    id: "elivmote49kcq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.33 406.91 130.33 419.88 127.08 419.88 115.55 456.28 89.98 456.28 78.81 420.24 74.48 419.88 74.48 406.91 130.33 406.91",
    style: {
      fill: "#9FC41C",
      transformOrigin: "102.405px 431.595px"
    },
    id: "elrkd1svu8tvc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el0y5eyzyv6cap"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "102.405px 431.595px"
    },
    className: "animable",
    id: "elrjyfmcvmtp"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "130.33 406.91 130.33 419.88 127.08 419.88 115.55 456.28 89.98 456.28 78.81 420.24 74.48 419.88 74.48 406.91 130.33 406.91",
    id: "elza4rfkfszxs",
    className: "animable",
    style: {
      transformOrigin: "102.405px 431.595px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M76.64,420.24c0,.15,11.3.27,25.22.27s25.22-.12,25.22-.27-11.29-.27-25.22-.27S76.64,420.09,76.64,420.24Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "101.86px 420.24px"
    },
    id: "elk9qzs3wmr4b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.25,336.79a10,10,0,0,0,1.64.44l4.49,1.09c3.78.93,9,2.35,14.61,4.25s10.64,3.9,14.22,5.44l4.23,1.85a10.75,10.75,0,0,0,1.57.64,9.92,9.92,0,0,0-1.48-.83c-1-.5-2.39-1.19-4.17-2a150.22,150.22,0,0,0-14.19-5.61,147.14,147.14,0,0,0-14.7-4.11c-1.91-.42-3.46-.73-4.54-.91A9.54,9.54,0,0,0,58.25,336.79Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "78.63px 343.645px"
    },
    id: "el4i0hof5ftf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.13,440.45c0,.15,7.93.27,17.7.27s17.69-.12,17.69-.27-7.92-.27-17.69-.27S85.13,440.3,85.13,440.45Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "102.825px 440.45px"
    },
    id: "els98deu2zcgp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.14,437.44c0,.15,8.4.27,18.75.27s18.75-.12,18.75-.27-8.39-.27-18.75-.27S84.14,437.29,84.14,437.44Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "102.89px 437.44px"
    },
    id: "el53x376wjg4t",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-12",
    className: "animable",
    style: {
      transformOrigin: "369px 456.485px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M709.46,456.48c0,.15-152.44.27-340.44.27s-340.48-.12-340.48-.27S181,456.22,369,456.22,709.46,456.34,709.46,456.48Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "369px 456.485px"
    },
    id: "el224vxy4psai",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubbles--inject-12",
    className: "animable",
    style: {
      transformOrigin: "536.655px 189.77px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "616.04 76.13 348.05 76.13 348.05 242.09 573.65 242.09 587.62 274.22 600 242.09 616.04 242.09 616.04 76.13",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "482.045px 175.175px"
    },
    id: "elxur59abdxr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616,76.12c0,1.61.07,64,.2,166v.2H600l.19-.13c-3.87,10.07-8.05,20.92-12.37,32.13l-.19.51-.22-.5c-4.38-10.06-9.11-20.95-14-32.13l.21.14-204,0H347.79v-.26c0-59.15,0-115.28,0-166v-.23h.24l268,.23-268,.24.24-.24c0,50.69,0,106.82,0,166l-.26-.26h21.58l204,0h.15l.06.14,14,32.14h-.41L599.81,242l.05-.14H616l-.2.2C616,140.08,616,77.73,616,76.12Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "481.995px 175.34px"
    },
    id: "el7jo42eba4g8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.9,92.32c0,.2-59.88.37-133.72.37s-133.73-.17-133.73-.37S408.32,92,482.18,92,615.9,92.12,615.9,92.32Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "482.175px 92.345px"
    },
    id: "elh3oupwc0rxe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.29,85a2.2,2.2,0,1,1-2.19-2.2A2.2,2.2,0,0,1,362.29,85Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "360.09px 85px"
    },
    id: "elgl14xyf4ob7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.24,85a2.2,2.2,0,1,1-2.19-2.2A2.2,2.2,0,0,1,370.24,85Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "368.04px 85px"
    },
    id: "elxcsrm92ahsb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.19,85a2.2,2.2,0,1,1-2.2-2.2A2.2,2.2,0,0,1,378.19,85Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "375.99px 85px"
    },
    id: "eltt0uq7fbh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.28,122l-6.36,2.46,6.36,2.45v1.49l-8-3.17V123.7l8-3.18Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "373.28px 124.46px"
    },
    id: "elamhp6uy6uo9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.9,115.65h1.56l-5.92,16.88H378Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "381.73px 124.09px"
    },
    id: "elwcrgv68zuqp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,123.7v1.54l-8,3.17v-1.49l6.38-2.45L386,122v-1.49Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "390px 124.46px"
    },
    id: "el1b5ngjgwuce",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.06,129.61a1.2,1.2,0,0,1,1.22-1.22,1.18,1.18,0,0,1,1.19,1.22,1.2,1.2,0,0,1-1.19,1.24A1.22,1.22,0,0,1,396.06,129.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "397.265px 129.62px"
    },
    id: "eln2svnz73x8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.14,129.61a1.19,1.19,0,0,1,1.22-1.22,1.18,1.18,0,0,1,1.18,1.22,1.2,1.2,0,0,1-1.18,1.24A1.21,1.21,0,0,1,400.14,129.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "401.34px 129.62px"
    },
    id: "el6fcn9uh3477",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.21,129.61a1.19,1.19,0,0,1,1.22-1.22,1.18,1.18,0,0,1,1.18,1.22,1.2,1.2,0,0,1-1.18,1.24A1.21,1.21,0,0,1,404.21,129.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "405.41px 129.62px"
    },
    id: "ele5lkhaysf2w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.5,145.71c0,.2-39.61.36-88.47.36s-88.48-.16-88.48-.36,39.61-.37,88.48-.37S546.5,145.5,546.5,145.71Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "458.025px 145.705px"
    },
    id: "elbcecl5x5o4t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.4,146.23c0,.2-3.8.37-8.5.37s-8.5-.17-8.5-.37,3.81-.37,8.5-.37S575.4,146,575.4,146.23Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "566.9px 146.23px"
    },
    id: "elzu97rfybz7g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.25,146.23c0,.2-4.16.37-9.28.37s-9.29-.17-9.29-.37,4.16-.37,9.29-.37S600.25,146,600.25,146.23Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "590.965px 146.23px"
    },
    id: "el4rqcjcp8ybr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.23,160.62c0,.2-25.18.36-56.24.36s-56.23-.16-56.23-.36,25.17-.37,56.23-.37S482.23,160.41,482.23,160.62Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "425.995px 160.615px"
    },
    id: "el14l6aoyxt06",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.42,216.25c0,.2-25.18.36-56.23.36s-56.24-.16-56.24-.36,25.18-.37,56.24-.37S481.42,216.05,481.42,216.25Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "425.185px 216.245px"
    },
    id: "el7vio1h9uwje",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.09,160.62c0,.2-6.85.36-15.3.36s-15.3-.16-15.3-.36,6.85-.37,15.3-.37S523.09,160.41,523.09,160.62Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "507.79px 160.615px"
    },
    id: "eln3clq22nfs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.77,216.25c0,.2-6.85.36-15.3.36s-15.3-.16-15.3-.36,6.85-.37,15.3-.37S522.77,216.05,522.77,216.25Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "507.47px 216.245px"
    },
    id: "elbjm09sg6fko",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.14,168.2c0,.2-1.7.37-3.8.37s-3.79-.17-3.79-.37,1.7-.36,3.79-.36S377.14,168,377.14,168.2Z",
    style: {
      fill: "#9FC41C",
      transformOrigin: "373.345px 168.205px"
    },
    id: "elowva189udtf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.29,168.36c0,.2-3.69.36-8.24.36s-8.24-.16-8.24-.36,3.69-.37,8.24-.37S403.29,168.16,403.29,168.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "395.05px 168.355px"
    },
    id: "elubqovc6gwh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420,168.36c0,.2-3.16.36-7.06.36s-7.06-.16-7.06-.36,3.16-.37,7.06-.37S420,168.16,420,168.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "412.94px 168.355px"
    },
    id: "elu88vnpxp2ck",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.22,168.36c0,.2-3.22.36-7.19.36s-7.2-.16-7.2-.36,3.22-.37,7.2-.37S441.22,168.16,441.22,168.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "434.025px 168.355px"
    },
    id: "eluhz6pqewkao",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.79,168.36c0,.2-2.93.36-6.54.36s-6.54-.16-6.54-.36,2.93-.37,6.54-.37S459.79,168.16,459.79,168.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "453.25px 168.355px"
    },
    id: "elzkxs69fchys",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.26,168.36c0,.2-12.88.36-28.77.36s-28.78-.16-28.78-.36,12.88-.37,28.78-.37S521.26,168.16,521.26,168.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "492.485px 168.355px"
    },
    id: "elmva8iv252g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.09,177.88c0,.2-1.46.37-3.27.37s-3.27-.17-3.27-.37,1.46-.37,3.27-.37S376.09,177.68,376.09,177.88Z",
    style: {
      fill: "#9FC41C",
      transformOrigin: "372.82px 177.88px"
    },
    id: "elp6nbggz2qa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.35,187.82c0,.2-1.52.37-3.4.37s-3.4-.17-3.4-.37,1.52-.37,3.4-.37S376.35,187.62,376.35,187.82Z",
    style: {
      fill: "#9FC41C",
      transformOrigin: "372.95px 187.82px"
    },
    id: "el4dhheuscorb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.35,199.07c0,.2-1.52.36-3.4.36s-3.4-.16-3.4-.36,1.52-.37,3.4-.37S376.35,198.86,376.35,199.07Z",
    style: {
      fill: "#9FC41C",
      transformOrigin: "372.95px 199.065px"
    },
    id: "el09kp4qv1sgpt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.34,198.54c0,.21-11.36.37-25.37.37s-25.37-.16-25.37-.37,11.36-.36,25.37-.36S438.34,198.34,438.34,198.54Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "412.97px 198.545px"
    },
    id: "eli8o372hhcu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.9,187.82c0,.2-10.84.37-24.2.37s-24.19-.17-24.19-.37,10.83-.37,24.19-.37S433.9,187.62,433.9,187.82Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "409.705px 187.82px"
    },
    id: "elx8zwki2racs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.82,177.36c0,.2-36.9.36-82.39.36s-82.4-.16-82.4-.36,36.88-.37,82.4-.37S550.82,177.15,550.82,177.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "468.425px 177.355px"
    },
    id: "elmlg4lm9dsek",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "632.5 144 632.5 285.04 610.57 303.33 632.5 303.33 634.66 303.33 725.26 303.33 725.26 144 632.5 144",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "667.915px 223.665px"
    },
    id: "elu3ddbbe1hdj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.5,144s.55,0,1.62,0l4.8,0,18.47,0,67.87-.1h.2v.2c0,42.57,0,98.17.06,159.33v.26H709.18l-98.61,0h-.66l.51-.43,21.94-18.29-.09.18c.05-42.17.09-77.45.12-102.2,0-12.35.05-22.07.06-28.71,0-3.3,0-5.83,0-7.56,0-.84,0-1.49,0-1.93s0-.64,0-.64,0,.23,0,.67,0,1.1,0,2c0,1.73,0,4.28,0,7.6,0,6.65,0,16.39.06,28.75,0,24.72.06,60,.11,102.06v.1l-.08.07-21.92,18.31-.16-.43,98.61,0h16.08l-.26.26c0-61.16,0-116.76.06-159.33l.2.19-67.75-.1L639,144l-4.84,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "667.715px 223.795px"
    },
    id: "elkqrrk1zo6a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.93,151a1.88,1.88,0,1,1-1.88-1.88A1.88,1.88,0,0,1,640.93,151Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "639.05px 151px"
    },
    id: "ellou7qw70an9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.73,151a1.88,1.88,0,1,1-1.88-1.88A1.88,1.88,0,0,1,647.73,151Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "645.85px 151px"
    },
    id: "elfp94iysdzww",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.53,151a1.88,1.88,0,1,1-1.88-1.88A1.88,1.88,0,0,1,654.53,151Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "652.65px 151px"
    },
    id: "eliyvfnyb186",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.76,194.47c0,.17-11.76.3-26.26.3s-26.26-.13-26.26-.3,11.75-.3,26.26-.3S699.76,194.3,699.76,194.47Z",
    style: {
      fill: "#9FC41C",
      transformOrigin: "673.5px 194.47px"
    },
    id: "elgcl92y4tdf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.72,207.23c0,.16-14.31.3-32,.3s-32-.14-32-.3,14.31-.3,32-.3S710.72,207.06,710.72,207.23Z",
    style: {
      fill: "#9FC41C",
      transformOrigin: "678.72px 207.23px"
    },
    id: "elkoihcp2qtud",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.32,254.83c0,.17-15.26.3-34.08.3s-34.08-.13-34.08-.3,15.26-.3,34.08-.3S713.32,254.67,713.32,254.83Z",
    style: {
      fill: "#9FC41C",
      transformOrigin: "679.24px 254.83px"
    },
    id: "el3eje48nkeo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.16,213.72a17.7,17.7,0,0,1-6.49,0,17.7,17.7,0,0,1,6.49,0Z",
    style: {
      fill: "#9FC41C",
      transformOrigin: "648.915px 213.72px"
    },
    id: "elbsz6yyps8re",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.55,213.85c0,.17-3.16.3-7,.3s-7-.13-7-.3a83,83,0,0,1,14.1,0Z",
    style: {
      fill: "#9FC41C",
      transformOrigin: "667.6px 213.85px"
    },
    id: "eldg7q7fay1t6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.87,213.85c0,.17-2.7.3-6,.3s-6.05-.13-6.05-.3a61.05,61.05,0,0,1,12.09,0Z",
    style: {
      fill: "#9FC41C",
      transformOrigin: "682.865px 213.85px"
    },
    id: "elot1ujn0fwz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.27,222a13.22,13.22,0,0,1-5.6,0,13.22,13.22,0,0,1,5.6,0Z",
    style: {
      fill: "#9FC41C",
      transformOrigin: "648.47px 222px"
    },
    id: "el03ha2nq226hi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.49,230.51a14.26,14.26,0,0,1-5.82,0,13.81,13.81,0,0,1,5.82,0Z",
    style: {
      fill: "#9FC41C",
      transformOrigin: "648.58px 230.505px"
    },
    id: "eltdnkvnrrymb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.49,240.13a14.26,14.26,0,0,1-5.82,0,14.26,14.26,0,0,1,5.82,0Z",
    style: {
      fill: "#9FC41C",
      transformOrigin: "648.58px 240.13px"
    },
    id: "elmz06joj2z5j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.54,239.68c0,.17-9.72.3-21.71.3s-21.71-.13-21.71-.3,9.72-.3,21.71-.3S704.54,239.52,704.54,239.68Z",
    style: {
      fill: "#9FC41C",
      transformOrigin: "682.83px 239.68px"
    },
    id: "el3otzdwc0vlr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.73,230.51c0,.16-9.27.3-20.7.3s-20.7-.14-20.7-.3,9.26-.31,20.7-.31S700.73,230.34,700.73,230.51Z",
    style: {
      fill: "#9FC41C",
      transformOrigin: "680.03px 230.505px"
    },
    id: "elez57agf3wnr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.73,267.54a14.26,14.26,0,0,1-5.82,0,14.26,14.26,0,0,1,5.82,0Z",
    style: {
      fill: "#9FC41C",
      transformOrigin: "652.82px 267.54px"
    },
    id: "el4e5d9akwnlf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.73,277.17a14.26,14.26,0,0,1-5.82,0,13.81,13.81,0,0,1,5.82,0Z",
    style: {
      fill: "#9FC41C",
      transformOrigin: "652.82px 277.165px"
    },
    id: "el29m46dmia2w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.78,276.72c0,.16-9.72.3-21.71.3s-21.71-.14-21.71-.3,9.71-.3,21.71-.3S708.78,276.55,708.78,276.72Z",
    style: {
      fill: "#9FC41C",
      transformOrigin: "687.07px 276.72px"
    },
    id: "elvg42szb0wq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705,267.54c0,.17-9.27.3-20.7.3s-20.71-.13-20.71-.3,9.27-.3,20.71-.3S705,267.37,705,267.54Z",
    style: {
      fill: "#9FC41C",
      transformOrigin: "684.295px 267.54px"
    },
    id: "elr1j1g3onx0p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.13,221.55c0,.17-12.62.3-28.18.3s-28.18-.13-28.18-.3,12.62-.3,28.18-.3S716.13,221.39,716.13,221.55Z",
    style: {
      fill: "#9FC41C",
      transformOrigin: "687.95px 221.55px"
    },
    id: "elhuwvu9jhf19",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.39,158.38c0,.16-20.37.3-45.49.3s-45.49-.14-45.49-.3,20.36-.3,45.49-.3S724.39,158.21,724.39,158.38Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "678.9px 158.38px"
    },
    id: "elmfjx8znmw9e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.43,186.78a154.07,154.07,0,0,1-19.22,0c0-.17,4.3-.3,9.61-.3S666.43,186.61,666.43,186.78Z",
    style: {
      fill: "#9FC41C",
      transformOrigin: "656.82px 186.78px"
    },
    id: "elijecfkeang",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.55,169.37c0,.17-2,.3-4.53.3s-4.53-.13-4.53-.3a34.35,34.35,0,0,1,9.06,0Z",
    style: {
      fill: "#9FC41C",
      transformOrigin: "651.02px 169.37px"
    },
    id: "el5j7atr5oje6",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-12",
    className: "animable",
    style: {
      transformOrigin: "553.763px 327.63px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M575.27,374.76l20.14-19.91-35.92-61.51a34.66,34.66,0,0,0-13.78-9.59l-12.65-4.81-31.45-5.77L479.29,282a13.35,13.35,0,0,0-8.37,14l5.84,49.16,3.44,64,81.13-14.08-8.16-23.67.27-36.92Z",
    style: {
      fill: "#9FC41C",
      transformOrigin: "533.118px 341.165px"
    },
    id: "el0hqy9vewgpfi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.91,369.82c.19,0,.24-12.79.11-28.56s-.38-28.56-.57-28.56-.24,12.79-.11,28.56S553.72,369.82,553.91,369.82Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "553.68px 341.26px"
    },
    id: "elk7n5y8ji22m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.94,379.2l-49-19.73a11.23,11.23,0,0,1-7-9.54l-3.58-47s.42-20-12.06-21l-7.11,2.79C463,289.64,460.73,303,462,313.32c1.77,14.66,2.51,35.41,4.5,48.14,1.63,10.41,7.88,18.64,17.78,22.25l60.38,13.07Z",
    style: {
      fill: "#9FC41C",
      transformOrigin: "506.308px 339.355px"
    },
    id: "elzs3a4msj3bi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.05,310.1a7.87,7.87,0,0,1,.15,1.07c.08.77.19,1.8.32,3.1.25,2.75.6,6.63,1,11.4s.9,10.56,1.45,16.91c.13,1.59.27,3.22.41,4.89a37.58,37.58,0,0,0,.63,5,8.35,8.35,0,0,0,2.43,4.4,16.45,16.45,0,0,0,4.53,2.81c13.51,5.85,26,10.68,35,14.07l10.74,4,2.92,1.07a5.79,5.79,0,0,1,1,.42,7.52,7.52,0,0,1-1-.29l-3-1c-2.57-.85-6.27-2.13-10.82-3.76-9.09-3.29-21.57-8-35.13-13.91a17.13,17.13,0,0,1-4.7-2.94,8.92,8.92,0,0,1-2.61-4.73,37.2,37.2,0,0,1-.62-5.12q-.21-2.5-.39-4.89c-.5-6.36-.94-12.09-1.32-16.93s-.62-8.65-.83-11.41c-.08-1.3-.14-2.34-.19-3.11A8,8,0,0,1,492.05,310.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "522.322px 344.67px"
    },
    id: "elngo1uczkaj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464,335.65a1.86,1.86,0,0,1,.1.63c0,.49.1,1.09.16,1.81.15,1.68.35,3.93.58,6.67s.61,6.16,1.1,9.86a94.25,94.25,0,0,0,2.22,11.91,17.56,17.56,0,0,0,2.39,5.67,32.43,32.43,0,0,0,3.66,4.5,31.28,31.28,0,0,0,7.85,5.89,29.56,29.56,0,0,0,8.61,2.82,2.85,2.85,0,0,1-.64,0,13.08,13.08,0,0,1-1.82-.23A24.1,24.1,0,0,1,481.8,383a30.88,30.88,0,0,1-8.06-5.87,31.8,31.8,0,0,1-3.76-4.57,18.16,18.16,0,0,1-2.5-5.86,89.82,89.82,0,0,1-2.18-12c-.45-3.72-.75-7.08-1-9.9s-.31-5.11-.37-6.69c0-.73,0-1.33,0-1.83A2.58,2.58,0,0,1,464,335.65Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "477.3px 360.539px"
    },
    id: "elacpkm4pqh2p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.93,368.54a7.13,7.13,0,0,1,.89-2.62,16.81,16.81,0,0,1,9.94-8.49,7.15,7.15,0,0,1,2.72-.47c0,.11-1,.31-2.56.91a19.59,19.59,0,0,0-5.56,3.3,19.29,19.29,0,0,0-4.13,5C485.39,367.59,485,368.57,484.93,368.54Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "491.705px 362.749px"
    },
    id: "elctnm5n0mvaj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elu1x4tus4was"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "515.25px 348.845px"
    },
    className: "animable",
    id: "elv6hdrrry6c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M536.85,373.6c-5.24-3-10.37-5.24-15.85-7.73s-10.85-5.69-14.43-10.52c-6.77-9.12-6-22.28-12.92-31.28L495,342.22c.42,5.55-.43,11,3.14,14.8,3,3.17,8.88,5.61,13,7,8.35,2.75,17.34,6.84,25.68,9.6",
    id: "el6af1vzkjsdm",
    className: "animable",
    style: {
      transformOrigin: "515.25px 348.845px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elhpkc910e23d"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "553.45 316.16 557.69 342.32 553.68 334.91 553.45 316.16",
    style: {
      opacity: 0.3,
      transformOrigin: "555.57px 329.24px"
    },
    className: "animable",
    id: "elmrfcbtbrqxh"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M490.57,300a4.25,4.25,0,0,1-1.13.09l-3.1.08c-2.61.07-6.21.2-10.18.48s-7.55.67-10.15,1l-3.07.36a5.6,5.6,0,0,1-1.13.08,4,4,0,0,1,1.1-.28c.72-.15,1.76-.33,3-.53,2.59-.4,6.18-.84,10.16-1.13s7.6-.36,10.22-.33c1.31,0,2.37.05,3.1.09A5.46,5.46,0,0,1,490.57,300Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "476.19px 300.953px"
    },
    id: "el3i32rdb05bp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492,325.06c0,.14-6.42.79-14.35,1.44s-14.39,1.08-14.4.93,6.41-.79,14.35-1.45S492,324.91,492,325.06Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "477.625px 326.244px"
    },
    id: "ellmr64ihb21j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.33,351.37a5.35,5.35,0,0,1-1,.58c-.67.35-1.65.81-2.9,1.33A59.94,59.94,0,0,1,470,357.86c-1.35.06-2.44.06-3.19,0a4.39,4.39,0,0,1-1.16-.09,5.73,5.73,0,0,1,1.16-.11c.75,0,1.83-.09,3.17-.2A73.76,73.76,0,0,0,480.28,356a72.85,72.85,0,0,0,10-3c1.25-.48,2.26-.88,3-1.17A5,5,0,0,1,494.33,351.37Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "479.99px 354.637px"
    },
    id: "el4ryhhbvsg8d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.76,364.87a25.72,25.72,0,0,0-4.86,3.9,27.16,27.16,0,0,0-3.39,5.23,5,5,0,0,1,.54-1.79,14.27,14.27,0,0,1,6-6.62A4.63,4.63,0,0,1,511.76,364.87Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "507.635px 369.435px"
    },
    id: "elawb0u4hj0g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.49,382.19a19.05,19.05,0,0,1,5.24-9.56c.12.1-1.42,2-2.86,4.65S529.64,382.24,529.49,382.19Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "532.113px 377.41px"
    },
    id: "elycblvxhtjwe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.55,285.3a49.44,49.44,0,0,1-6.93,1.52,48.7,48.7,0,0,1-7,1,47.4,47.4,0,0,1,6.93-1.52A48.7,48.7,0,0,1,501.55,285.3Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "494.585px 286.56px"
    },
    id: "el7obet9cuy0w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.48,287.44a90.29,90.29,0,0,1-9.62-.88,87.75,87.75,0,0,1-9.55-1.4,93.55,93.55,0,0,1,9.62.88A90.79,90.79,0,0,1,548.48,287.44Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "538.895px 286.3px"
    },
    id: "el5kfrkc3jkjo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.48,309.26a2.07,2.07,0,0,1-.61,0l-1.76,0h-6.47c-5.46,0-13,0-21.33.25s-15.86.56-21.32.85l-6.46.34-1.75.07a2.09,2.09,0,0,1-.62,0,3.38,3.38,0,0,1,.61-.09l1.75-.18c1.52-.14,3.72-.31,6.45-.5,5.45-.38,13-.78,21.33-1s15.88-.2,21.35-.1c2.73.05,4.94.11,6.46.18l1.76.08A3.27,3.27,0,0,1,552.48,309.26Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "522.32px 309.811px"
    },
    id: "elvkiz2yzj6jb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.06,336.91c0,.14-12.85,1.1-28.72,2.15s-28.75,1.77-28.76,1.63,12.85-1.11,28.72-2.15S553.05,336.76,553.06,336.91Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "524.32px 338.799px"
    },
    id: "elpz6ma8f4gut",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.69,361.26a5.76,5.76,0,0,1-1.08.46c-.71.27-1.74.62-3,1-2.57.84-6.16,1.89-10.17,2.86s-7.68,1.66-10.35,2.07c-1.34.22-2.42.37-3.17.45a6.08,6.08,0,0,1-1.18.08,5.34,5.34,0,0,1,1.15-.28l3.13-.61c2.65-.51,6.3-1.26,10.3-2.22s7.59-1.95,10.18-2.7l3.07-.89A4.64,4.64,0,0,1,551.69,361.26Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "537.215px 364.721px"
    },
    id: "el82nljaa9kbx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.26,317.12a89.43,89.43,0,0,1-9.34,2.68,91.06,91.06,0,0,1-9.47,2.18,91.28,91.28,0,0,1,9.34-2.68A88.66,88.66,0,0,1,572.26,317.12Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "562.855px 319.55px"
    },
    id: "eljtyq8dagg4i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.45,298.43a17.11,17.11,0,0,1-4.13,1,17.61,17.61,0,0,1-4.24.5,18,18,0,0,1,4.14-1A17.55,17.55,0,0,1,562.45,298.43Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "558.265px 299.18px"
    },
    id: "elk6c0jrapsi9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.2,304.23c-.1,0-.26-1.66-1.17-4.17a21.11,21.11,0,0,0-14.86-13.36c-2.6-.64-4.29-.61-4.28-.71a4.38,4.38,0,0,1,1.18-.05,18.31,18.31,0,0,1,3.18.41,20.34,20.34,0,0,1,15.12,13.59,17.14,17.14,0,0,1,.74,3.12A4.3,4.3,0,0,1,492.2,304.23Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "482.049px 295.076px"
    },
    id: "el5144rlzwfwf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.6,290.9a80.32,80.32,0,0,1,1.73,9.14,80.84,80.84,0,0,1,1.21,9.23,84.48,84.48,0,0,1-1.72-9.15A82.68,82.68,0,0,1,550.6,290.9Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "552.07px 300.085px"
    },
    id: "ell3gc5sstux",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.24,438.29s37.68,10.42,39.19,11c2.27.8,1.89,9.11-1.64,9-1.67-.06-28.94,1-32.39.8s-13.84-4.31-13.84-4.31Z",
    style: {
      fill: "#9FC41C",
      transformOrigin: "621.206px 448.703px"
    },
    id: "elqc93arjkdo9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.94,452.66c.19,0,.44-2,1.66-4s2.78-3.32,2.66-3.47-1.94.92-3.21,3.15S620.78,452.68,620.94,452.66Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "623.067px 448.918px"
    },
    id: "elh7y19cwuoye",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617,450.88c.18,0,.56-1.75,1.57-3.72s2.19-3.34,2-3.47a7.18,7.18,0,0,0-2.62,3.19C617,449,616.85,450.87,617,450.88Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "618.77px 447.285px"
    },
    id: "elzisfhovjj5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.32,449.9c.19,0,0-1.9.88-4s2.19-3.38,2.06-3.52-1.77,1-2.64,3.3S613.17,450,613.32,449.9Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "614.678px 446.136px"
    },
    id: "elna40x3nklec",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614,445a6.72,6.72,0,0,0,.41-2.81,13.56,13.56,0,0,0-.39-3.07,11.78,11.78,0,0,0-.56-1.75,2.09,2.09,0,0,0-.6-.92,1,1,0,0,0-1.29.06,1.67,1.67,0,0,0-.51,1.07,8.45,8.45,0,0,0,0,1,7.81,7.81,0,0,0,.23,1.85,11.43,11.43,0,0,0,1.16,2.88,7.78,7.78,0,0,0,1.69,2.27c.09-.06-.54-.94-1.3-2.48a12.81,12.81,0,0,1-1-2.8,8.64,8.64,0,0,1-.18-1.72c0-.58,0-1.3.35-1.58a.36.36,0,0,1,.5,0,1.5,1.5,0,0,1,.41.66,13.07,13.07,0,0,1,.57,1.66,14.94,14.94,0,0,1,.5,2.94C614.06,444,613.89,445,614,445Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "612.735px 440.911px"
    },
    id: "elwhtb3k9rm7d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614,444.65a5.27,5.27,0,0,0-2.44-.4,11,11,0,0,0-2.67.33,5.82,5.82,0,0,0-1.54.57,1.6,1.6,0,0,0-.85,1.72,1.86,1.86,0,0,0,1.36,1.34,3.45,3.45,0,0,0,1.69,0A6.68,6.68,0,0,0,612,447a6.92,6.92,0,0,0,1.75-1.73,16.4,16.4,0,0,0-2,1.36,6.62,6.62,0,0,1-2.31,1,2.88,2.88,0,0,1-1.4,0,1.29,1.29,0,0,1-.92-.89,1,1,0,0,1,.56-1.06,6,6,0,0,1,1.37-.53,12.79,12.79,0,0,1,2.54-.44C613,444.6,613.93,444.75,614,444.65Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "610.237px 446.275px"
    },
    id: "el9kmg5fxdos",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.73,453.07c.18,0,0-1.63.74-3.4s2-2.81,1.84-2.95-1.63.74-2.42,2.71S626.57,453.13,626.73,453.07Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "627.884px 449.889px"
    },
    id: "elcwnbs7fmsq9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.44,454.81a7.66,7.66,0,0,0,1.45.68,31.53,31.53,0,0,0,4.2,1.3,59.68,59.68,0,0,0,14.38,1.36c5.65-.06,10.74-.31,14.43-.46l4.36-.23a8.44,8.44,0,0,0,1.6-.17,7.29,7.29,0,0,0-1.61-.08l-4.37,0-14.41.28a67.89,67.89,0,0,1-14.29-1.16C602.58,455.62,600.48,454.69,600.44,454.81Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "620.65px 456.486px"
    },
    id: "el21ujk5kostf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.32,455.67c0,.08,1.08-.52,2.82-1.28a13.08,13.08,0,0,1,7.13-1.19,11.31,11.31,0,0,1,6.17,3.67,22.57,22.57,0,0,0,2.17,2.22,11.68,11.68,0,0,0-1.85-2.53,15,15,0,0,0-2.49-2.33,9,9,0,0,0-3.9-1.65A12.44,12.44,0,0,0,602,454,9.84,9.84,0,0,0,599.32,455.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "608.465px 455.793px"
    },
    id: "el9kvdisiwxvv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.65,429.54S525,452.88,523.71,453.85c-1.92,1.45.28,8.36,3.61,7.16,1.57-.56,31.49-8.89,34.71-10.14s11.88-8.31,11.88-8.31Z",
    style: {
      fill: "#9FC41C",
      transformOrigin: "548.453px 445.345px"
    },
    id: "el1su6txet4uz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.06,448c.15,0-.48-2.09-2.39-3.81s-4-2.19-4-2,1.82.86,3.59,2.49S549.89,448.09,550.06,448Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "546.876px 445.077px"
    },
    id: "elvfoabho1vo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.26,445.11c.15-.05-.54-1.85-2.17-3.5s-3.4-2.4-3.46-2.25,1.47,1.1,3,2.69S553.09,445.2,553.26,445.11Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "550.454px 442.227px"
    },
    id: "elpbd28ubft8b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.47,443.05c.16,0,0-2-1.56-3.92s-3.48-2.49-3.51-2.33,1.62,1,3,2.73S556.29,443.1,556.47,443.05Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "553.959px 439.913px"
    },
    id: "ely78igal86h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.36,438.62c.09,0-.4-1-.81-2.67a15.59,15.59,0,0,1-.42-2.95,15,15,0,0,1,0-1.76,1.59,1.59,0,0,1,.19-.75.37.37,0,0,1,.49-.11c.41.16.62.85.81,1.4a8.08,8.08,0,0,1,.35,1.69,12.35,12.35,0,0,1-.09,3c-.25,1.69-.58,2.72-.48,2.75a7.59,7.59,0,0,0,.92-2.67,11.38,11.38,0,0,0,.23-3.1,8.16,8.16,0,0,0-.34-1.83,7.61,7.61,0,0,0-.35-.93,1.66,1.66,0,0,0-.8-.86,1,1,0,0,0-1.25.33,2.17,2.17,0,0,0-.3,1.06,14.11,14.11,0,0,0,0,1.84,12.86,12.86,0,0,0,.57,3A6.54,6.54,0,0,0,554.36,438.62Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "554.026px 434.476px"
    },
    id: "elc50r7wle2c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.28,438.24c.05.09.88-.33,2.32-.68a12.87,12.87,0,0,1,2.55-.35,6,6,0,0,1,1.47.09,1,1,0,0,1,.85.83,1.3,1.3,0,0,1-.6,1.14,3,3,0,0,1-1.33.44,6.61,6.61,0,0,1-2.5-.25,17.91,17.91,0,0,0-2.33-.69,6.53,6.53,0,0,0,2.2,1.11,6.43,6.43,0,0,0,2.69.41,3.56,3.56,0,0,0,1.62-.51,1.89,1.89,0,0,0,.88-1.7,1.59,1.59,0,0,0-1.33-1.38,6.18,6.18,0,0,0-1.64-.07,11,11,0,0,0-2.65.5A5.46,5.46,0,0,0,554.28,438.24Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "558.191px 438.453px"
    },
    id: "elqrhgrw9495",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.86,459.71c0,.06.6-.36.88-1.38a5.25,5.25,0,0,0-.67-3.87,13.44,13.44,0,0,0-1.2-1.78,6.38,6.38,0,0,0-1.21-1.3,2.19,2.19,0,0,0-1.14-.48c-.29,0-.45.06-.44.1a3.4,3.4,0,0,1,1.3.72,8.54,8.54,0,0,1,1,1.3,20.12,20.12,0,0,1,1.12,1.74,5.56,5.56,0,0,1,.78,3.48A14.06,14.06,0,0,1,531.86,459.71Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "530.468px 455.308px"
    },
    id: "elk3q1rn0hxdi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.66,450.15c.17,0,.12-1.8-1.25-3.42s-3.13-2-3.14-1.84,1.44.76,2.65,2.25S544.48,450.18,544.66,450.15Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "542.5px 447.503px"
    },
    id: "eldnz9ejokblq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.24,443.82a11.36,11.36,0,0,0-1.57,1.08,45.45,45.45,0,0,1-4.39,2.69,58.48,58.48,0,0,1-7,3.11c-2.7,1-5.73,1.95-8.93,2.88-6.42,1.85-12.23,3.54-16.42,4.8l-5,1.52a10.26,10.26,0,0,0-1.79.64,11.91,11.91,0,0,0,1.86-.41l5-1.32c4.22-1.15,10-2.77,16.46-4.62,3.21-.93,6.25-1.9,9-2.95a52.78,52.78,0,0,0,7-3.26,34.3,34.3,0,0,0,4.33-2.89A9.16,9.16,0,0,0,570.24,443.82Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "547.69px 452.18px"
    },
    id: "elr6tpm2knbg9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.56,444.3a9.71,9.71,0,0,0-3-.8,12.46,12.46,0,0,0-7.49.91,9,9,0,0,0-3.21,2.76,15,15,0,0,0-1.67,3,11.68,11.68,0,0,0-1,3,22.07,22.07,0,0,0,1.39-2.77c.85-1.66,2.19-4.09,4.76-5.37a13.2,13.2,0,0,1,7.16-1C570.38,444.14,571.54,444.4,571.56,444.3Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "563.375px 448.227px"
    },
    id: "eltmrq7ukhst",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.77,371.16S645.46,375,645.51,387c.08,23-46.42,48.3-46.42,48.3l-61.89-41-3.88-1.57S616.86,361.31,634.77,371.16Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "589.415px 402.274px"
    },
    id: "ellmfdygsm5ea",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.55,415a10.06,10.06,0,0,0,1.61-1.09c1-.73,2.46-1.83,4.24-3.2,3.54-2.73,8.36-6.62,13.55-11.07s9.75-8.63,13-11.72c1.62-1.54,2.92-2.81,3.8-3.7a10.46,10.46,0,0,0,1.32-1.43,12.11,12.11,0,0,0-1.49,1.25l-3.93,3.55c-3.32,3-7.93,7.13-13.11,11.57s-9.94,8.38-13.41,11.21L570,413.69A11.92,11.92,0,0,0,568.55,415Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "587.31px 398.895px"
    },
    id: "el347eoqpgm79",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.3,379.74a12.32,12.32,0,0,0-6,.55c-3.23.94-5.4,2.66-5.3,2.78s2.36-1.27,5.48-2.18S617.3,379.94,617.3,379.74Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "611.648px 381.334px"
    },
    id: "el5t36k6kwh1q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612,376.12a7.59,7.59,0,0,0-3.66,2.76c-1.65,2-2.09,4.15-1.93,4.17s.86-1.86,2.42-3.77S612.06,376.29,612,376.12Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "609.19px 379.585px"
    },
    id: "elnvqjmbueve",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.17,448.87c0-.07-.74-.22-1.6.48a5.78,5.78,0,0,0-1.78,3.59,6.93,6.93,0,0,0,.56,4c.44.94.92,1.39,1,1.34s-.25-.58-.56-1.5a8.17,8.17,0,0,1-.35-3.71,6.21,6.21,0,0,1,1.46-3.35C637.53,449,638.18,449,638.17,448.87Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "636.438px 453.545px"
    },
    id: "elrtfyhpxap4g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.34,338.53,612.74,386a6.84,6.84,0,0,1-6.5,4.46l-96.92-1.28v-7.36l36,1.31,15.26-47.34a3.88,3.88,0,0,1,3.69-2.68l62.52.18A3.87,3.87,0,0,1,630.34,338.53Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "569.955px 361.785px"
    },
    id: "ell35pog4vmsp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.34,338.53s0,0,0-.15a2.57,2.57,0,0,0,.12-.44,3.75,3.75,0,0,0,0-1.79,3.8,3.8,0,0,0-3.46-2.84c-.66,0-1.39,0-2.15,0l-26.08,0-18.27,0-10.27,0h-5.39a4.25,4.25,0,0,0-2.58.57,3.79,3.79,0,0,0-1.61,2.11l-15.22,47.26,0,.11h-.12l-36-1.3.16-.16v7.36l-.15-.15,60.94.81,26.49.37,6.11.08,3,0a7,7,0,0,0,2.81-.41,6.67,6.67,0,0,0,3.89-3.74c.64-1.72,1.27-3.41,1.89-5.05,4.91-13.17,8.88-23.81,11.62-31.17,1.38-3.66,2.44-6.51,3.17-8.45s1.12-2.93,1.12-2.93-.35,1-1.06,3L626.16,350c-2.72,7.37-6.65,18-11.53,31.2l-1.88,5.07a6.92,6.92,0,0,1-4,3.87,7.36,7.36,0,0,1-2.91.44l-3,0-6.1-.08-26.49-.33-60.95-.79h-.15v-7.68h.16l36,1.32-.15.11,15.26-47.25a4,4,0,0,1,1.72-2.25,4.51,4.51,0,0,1,2.72-.6l5.39,0,10.27,0,18.27.08,26.08.12c.76,0,1.48,0,2.16,0a3.88,3.88,0,0,1,3.51,2.93,3.71,3.71,0,0,1,0,1.8A3.52,3.52,0,0,1,630.34,338.53Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "569.9px 361.799px"
    },
    id: "elmj5827ltdm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.37,356.46a4.36,4.36,0,0,1,4.71.5,3.83,3.83,0,0,1,.92,4.18,4.12,4.12,0,0,1-3.54,2.47,3.71,3.71,0,0,1-3.74-2.47c-.45-1.55,0-3.86,1.65-4.68",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "589.412px 359.804px"
    },
    id: "elydcq0xkx9z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.52,437.85s-87.34-55.94-91.19-58.14c-3.28-1.87-12.06-7.27-20.71-4.88S481.21,385,477.33,396.31c-2.21,6.48-3.26,17.53-3.75,25.82a38.3,38.3,0,0,0,9,27.31,24.53,24.53,0,0,0,10.9,7.74c.91.28,1.86.52,2.83.73,16.53,3.59,33.52-3.83,42.81-18l2-3.1s57.2,21,58.09,20.71Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "541.508px 416.519px"
    },
    id: "elqcjpazniaeh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.84,382.81s-.08,0-.22-.13l-.61-.42c-.54-.37-1.33-.91-2.36-1.58a46.84,46.84,0,0,0-9.28-4.71,24.74,24.74,0,0,0-7-1.47,20,20,0,0,0-8,1.31,25.72,25.72,0,0,0-7.72,4.68,35.13,35.13,0,0,0-3.43,3.37,24.71,24.71,0,0,0-2.84,4,41,41,0,0,0-3.76,9c-.83,3.05-1.49,6.06-2.11,8.9a80.91,80.91,0,0,0-2,15.32,55.61,55.61,0,0,0,.79,10.39c.19,1.22.41,2.15.54,2.79l.14.73a.79.79,0,0,1,0,.25,1.29,1.29,0,0,1-.08-.24c0-.19-.12-.43-.19-.72-.17-.63-.42-1.55-.64-2.77a51.94,51.94,0,0,1-1-10.43A78.53,78.53,0,0,1,475,405.69c.62-2.86,1.26-5.85,2.08-8.94a42.14,42.14,0,0,1,3.81-9.12,25.53,25.53,0,0,1,2.9-4.11,35.13,35.13,0,0,1,3.49-3.42,26.21,26.21,0,0,1,7.88-4.74,20.4,20.4,0,0,1,8.23-1.3,25.39,25.39,0,0,1,7.08,1.56,43.87,43.87,0,0,1,9.27,4.89c1,.7,1.79,1.27,2.31,1.67l.58.46A.88.88,0,0,1,522.84,382.81Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "497.955px 404.638px"
    },
    id: "elah7xlj95tu4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.35,422.06a4.66,4.66,0,0,0,.48.22l1.43.56L508.8,425l20.6,7.76c8.75,3.26,19.24,7.15,31,11.43s24.79,9,38.71,13.68l.26.08.12-.23c2.18-4.18,4.49-8.58,6.83-13.05L609.8,438l.14-.26-.25-.15L543,395.25l-20-12.64-5.44-3.4-1.42-.86a5.35,5.35,0,0,0-.49-.28s.15.12.46.33l1.39.92,5.38,3.49,19.93,12.8,66.58,42.51-.11-.41c-1.1,2.11-2.28,4.37-3.48,6.65l-6.82,13.05.37-.16c-13.91-4.7-26.95-9.37-38.72-13.61l-31-11.29-20.67-7.58-5.58-2-1.45-.51Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "555.645px 418.01px"
    },
    id: "eljzdsucez2j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.87,236.47a44.87,44.87,0,0,1-3.88-9.29,15.13,15.13,0,0,1,.52-9.88c.81-1.79,2.09-3.36,2.73-5.22.87-2.56.51-5.58,2.1-7.77,2.47-3.43,7.77-2.63,11.6-4.42,3-1.4,5.07-4.41,8.2-5.42,2.74-.88,5.73,0,8.37,1.1s5.23,2.57,8.08,2.94a54.84,54.84,0,0,0,6.15,0,8.09,8.09,0,0,1,5.67,2c1.44,1.45,1.74,4.14.18,5.47,3.59-.61,7,3,6.92,6.61s-2.79,6.84-6.1,8.36-7.08,1.61-10.71,1.32c-10.27-.8-20.59-4.7-27.58-12.26",
    style: {
      fill: "#9FC41C",
      transformOrigin: "531.955px 215.29px"
    },
    id: "elmc4yi1y9l0b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.08,223.62l-7,50.85a15.26,15.26,0,0,0,13.79,17.29h0a15.28,15.28,0,0,0,16.46-13.15c.52-3.83,1-7,1-7.41,0,0,13.11.56,15.81-12.12,1.3-6.13,3-19,4.32-30.61A24.15,24.15,0,0,0,533.26,202l-1.23-.24C518.65,199.87,509.58,210.19,508.08,223.62Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "526.78px 246.677px"
    },
    id: "el9c5d99klwh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.45,271a30.22,30.22,0,0,1-15.64-8s2.09,9.94,15,11.33Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "524.63px 268.665px"
    },
    id: "elq171509wfv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.82,239.28a1.85,1.85,0,0,1-2.12,1.48,1.77,1.77,0,0,1-1.54-2,1.85,1.85,0,0,1,2.11-1.49A1.77,1.77,0,0,1,546.82,239.28Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "544.991px 239.016px"
    },
    id: "elgsby2tpkqy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.54,234.16c-.27.19-1.44-1.1-3.4-1.48s-3.58.3-3.74,0c-.08-.13.23-.51,1-.84a5,5,0,0,1,3-.31,4.86,4.86,0,0,1,2.65,1.48C548.56,233.61,548.68,234.08,548.54,234.16Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "544.991px 232.803px"
    },
    id: "eljul1zc5g2b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.6,236.13a1.85,1.85,0,0,1-2.12,1.48,1.76,1.76,0,0,1-1.54-2,1.84,1.84,0,0,1,2.11-1.48A1.77,1.77,0,0,1,528.6,236.13Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "526.769px 235.87px"
    },
    id: "el1h89snaf56o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.27,230.69c-.28.19-1.45-1.1-3.41-1.49s-3.58.31-3.74,0c-.08-.13.23-.51,1-.84a5,5,0,0,1,3-.31,4.92,4.92,0,0,1,2.65,1.47C529.28,230.14,529.4,230.6,529.27,230.69Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "525.713px 229.328px"
    },
    id: "elodnhq1bxdws",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.46,246.6a12.82,12.82,0,0,1,3.29.06c.51.05,1,0,1.15-.28a2.57,2.57,0,0,0,0-1.55c-.22-1.3-.46-2.66-.71-4.09-1-5.82-1.56-10.56-1.33-10.6s1.21,4.65,2.18,10.47c.22,1.43.44,2.79.65,4.1a3,3,0,0,1-.13,2,1.3,1.3,0,0,1-1,.57,3.33,3.33,0,0,1-.87-.06A13,13,0,0,1,533.46,246.6Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "536.132px 238.713px"
    },
    id: "elmecrwz6fc7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.44,246.8c.32,0-.1,2.17,1.42,4s3.82,2.09,3.77,2.39c0,.14-.58.31-1.54.15a5.42,5.42,0,0,1-3.18-1.88,4.7,4.7,0,0,1-1-3.35C527,247.24,527.3,246.76,527.44,246.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "529.761px 250.101px"
    },
    id: "elsey29h7e9q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.3,223.13c-.3.49-2.2-.15-4.55-.33s-4.32.07-4.53-.46c-.09-.26.33-.69,1.18-1.06a8,8,0,0,1,6.92.61C531.09,222.39,531.43,222.9,531.3,223.13Z",
    style: {
      fill: "#9FC41C",
      transformOrigin: "526.768px 222.037px"
    },
    id: "elgloc9n1wr7o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549,228.36c-.44.38-1.69-.35-3.3-.7s-3-.3-3.28-.82c-.09-.26.21-.66.9-1a4.88,4.88,0,0,1,5.29,1.23C549.05,227.68,549.15,228.18,549,228.36Z",
    style: {
      fill: "#9FC41C",
      transformOrigin: "545.735px 226.996px"
    },
    id: "eljk5vxspoi3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.24,233.24c-.2-.14-8.22-4.33-9.68,4.42s7.63,8.41,7.68,8.16S507.24,233.24,507.24,233.24Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "502.321px 239.013px"
    },
    id: "elx3mc1jmyfem",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.12,242.06s-.17.08-.44.15a1.55,1.55,0,0,1-1.15-.16c-.87-.5-1.4-2.09-1.18-3.68a5.18,5.18,0,0,1,.79-2.11,1.82,1.82,0,0,1,1.34-1,.79.79,0,0,1,.83.57c.08.27,0,.43,0,.45s.21-.11.2-.48a1,1,0,0,0-.25-.61,1.16,1.16,0,0,0-.81-.36,2.17,2.17,0,0,0-1.82,1.09,5.2,5.2,0,0,0-.93,2.35c-.24,1.77.39,3.57,1.59,4.15a1.69,1.69,0,0,0,1.44,0C503.07,242.27,503.15,242.08,503.12,242.06Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "501.58px 238.706px"
    },
    id: "eljxbv4kaq3x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555,216.66c-1.5,3.23-9.22,4.48-14.88,2.77-5.21-1.57-7.11-4.88-10.42-7.77-2.1-1.83-2.1-1.83-5.53-2.18-2.77-.29-5,2.47-7.09,4.3,1.17,7-1.92,13.84-4.94,20.21a3.51,3.51,0,0,1-1.41,1.81c-1.18.58-2.6-.34-3.31-1.46a11,11,0,0,1-1.23-6.14,36.54,36.54,0,0,1,2.91-14.08,24.74,24.74,0,0,1,9.14-11,23.5,23.5,0,0,1,17.4-2.88,28.88,28.88,0,0,1,15.25,9.15,16.86,16.86,0,0,1,4.11,7.22",
    style: {
      fill: "#9FC41C",
      transformOrigin: "530.572px 217.825px"
    },
    id: "elqbske1i7o7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.24,237.8c.08,0,0-.75.4-2a8.52,8.52,0,0,1,3.1-4.5,8.24,8.24,0,0,1,7.74-1.11,8.1,8.1,0,0,1,3.77,2.85,8.11,8.11,0,0,1,0,9.59,8.1,8.1,0,0,1-3.77,2.85,8.22,8.22,0,0,1-7.74-1.12,8.47,8.47,0,0,1-3.1-4.49c-.35-1.28-.32-2-.4-2a2.15,2.15,0,0,0,0,.55,6.4,6.4,0,0,0,.18,1.55,8.38,8.38,0,0,0,3.06,4.83A8.7,8.7,0,0,0,552.8,243a8.7,8.7,0,0,0,0-10.41,8.7,8.7,0,0,0-12.36-1.72,8.36,8.36,0,0,0-3.06,4.82,6.52,6.52,0,0,0-.18,1.56A2,2,0,0,0,537.24,237.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "545.862px 237.811px"
    },
    id: "ell8g1xsbz4o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.49,234.18c.08,0,0-.75.4-2a8.49,8.49,0,0,1,3.1-4.5,8.22,8.22,0,0,1,7.74-1.11,8.08,8.08,0,0,1,3.77,2.84,8.12,8.12,0,0,1,0,9.6,8,8,0,0,1-3.77,2.84,8.22,8.22,0,0,1-7.74-1.11,8.49,8.49,0,0,1-3.1-4.5c-.35-1.27-.32-2-.4-2a2.1,2.1,0,0,0,0,.54,6.52,6.52,0,0,0,.18,1.56,8.38,8.38,0,0,0,3.06,4.83,8.72,8.72,0,0,0,12.37-1.72,8.73,8.73,0,0,0,0-10.42,8.7,8.7,0,0,0-12.36-1.72,8.41,8.41,0,0,0-3.06,4.83,6.52,6.52,0,0,0-.18,1.56A2,2,0,0,0,516.49,234.18Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "525.149px 234.238px"
    },
    id: "elwgeygq7k11m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.59,234.48c.09.17,1.2-.35,2.49.05s1.94,1.43,2.11,1.33,0-.37-.25-.81a3.09,3.09,0,0,0-3.69-1.11C533.76,234.14,533.54,234.4,533.59,234.48Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "535.921px 234.793px"
    },
    id: "elsn4ndjrrzhq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.74,231.94c0,.2,2.79.31,6.23.27s6.22-.25,6.22-.45-2.79-.31-6.23-.26S504.74,231.74,504.74,231.94Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "510.965px 231.853px"
    },
    id: "elrjw39ftlvf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.13,208.31a2.57,2.57,0,0,1-.14.83,4.08,4.08,0,0,1-1.31,1.88,5.78,5.78,0,0,1-3.15,1.29,15.74,15.74,0,0,1-4.17-.22,73.36,73.36,0,0,1-7.42-1.49c-.94-.25-1.7-.46-2.21-.62l-.6-.19-.2-.08s.08,0,.21,0l.61.15,2.22.55c1.88.45,4.5,1,7.42,1.44a15.88,15.88,0,0,0,4.12.23,5.74,5.74,0,0,0,3.08-1.21,4.12,4.12,0,0,0,1.32-1.79C559.09,208.61,559.1,208.3,559.13,208.31Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "549.53px 210.335px"
    },
    id: "elxzxonmsk5kc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.07,210.29a8.08,8.08,0,0,1-.75,2.4,10.24,10.24,0,0,1-9.87,5.89,8.09,8.09,0,0,1-2.46-.47,4.33,4.33,0,0,1,.66.13,12.31,12.31,0,0,0,1.81.2,10.4,10.4,0,0,0,9.72-5.82,9.66,9.66,0,0,0,.68-1.69A5,5,0,0,1,561.07,210.29Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "554.53px 214.444px"
    },
    id: "elum3hy89gpr",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeTypingAnimate);
export default __webpack_public_path__ + "static/media/code-typing-animate.88ae991cd35462e8871d5f426ccb2817.svg";
export { ForwardRef as ReactComponent };